import DataGrid, { Column, Format, Summary, TotalItem } from 'devextreme-react/data-grid';
import { formatNumber } from 'devextreme/localization';
import { useContext } from 'react';
import { WorkOrderContext } from '../context/WorkOrderContext';

export default function WorkOrderProductsPanel() {

	const { order } = useContext(WorkOrderContext);

	if (!order.details.products?.length)
		return null;

	return (
        <div className='dx-card wide-card'>
            <div className='grid-header'>WORK ORDER PAYMENT DETAILS</div>

            <DataGrid
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                showColumnLines={true}
                columnAutoWidth={true}
                dataSource={order.details.products}
                keyExpr={'woProductID'}
            >
                <Column
                    dataField={'itemDescription'}
                    caption={'Item Description'}
                    dataType="string"
                />
                <Column
                    dataField={'sku'}
                    caption={'SKU'}
                    dataType="string"
                />
                <Column
                    dataField={'qty'}
                    caption={'Qty'}
                    dataType="number"
                />
                <Column
                    dataField={'cfiPrice'}
                    caption={'CFI Unit'}
                    dataType="number"
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
                <Column
                    dataField={'cfiExtendedPrice'}
                    caption={'CFI Extended'}
                    dataType="number"
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
                <Summary>
                    <TotalItem
                        column="cfiExtendedPrice"
                        summaryType="sum"
                        customizeText={(data: any) => 'Total CFI Payment: ' + formatNumber(data.value, {
                            type: 'currency',
                            precision: 2
                        })}
                    />
                </Summary>
            </DataGrid>
        </div>
	);
}

